'use strict';

module.exports = exports = require('./naiveBayes').NaiveBayes;
exports.separateClasses = require('./naiveBayes').separateClasses;



// WEBPACK FOOTER //
// ./node_modules/ml-naivebayes/src/index.js